export default function TestExpired() {
  return (
    <div style={{ textAlign: "center", padding: "60px" }}>
      <h2>⛔ Test Expired</h2>
      <p>This test ID has already been used or expired.</p>
    </div>
  );
}
